import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

export interface ArrivalsDeparturesSwitcherProps {
  showArrivals: boolean;
  onChange: Function;
}

const ArrivalsDeparturesSwitcher = ({ showArrivals, onChange }: ArrivalsDeparturesSwitcherProps) => {
  const ref = useRef<HTMLDivElement>(null);
  const [arrivalsMode, setArrivalsMode] = useState(showArrivals);
  const { t } = useTranslation();

  useEffect(() => {
    onChange(arrivalsMode);
  }, [arrivalsMode]);

  useEffect(() => {
    setArrivalsMode(showArrivals);
  }, [showArrivals]);

  return (
    <div ref={ref} className={`arrivals-departures-switcher ${arrivalsMode ? 'arrivals' : 'departures'}`}>
      <h3 className="arrivals-text" onClick={() => setArrivalsMode(true)}>
        {t('arrivalsdepartures.arrivals')}
      </h3>
      <div className={`switch-handle ${arrivalsMode ? 'arrivals' : 'departures'}`}>
        <div
          role="button"
          className={`switch-handle-dot ${arrivalsMode ? 'arrivals' : 'departures'}`}
          onClick={() => setArrivalsMode((current) => !current)}
        >
          <img src="/Assets/icons/switch-dot.svg" alt="arrival departure switch dot icon" width="10" />
        </div>
      </div>
      <h3 className="departures-text" onClick={() => setArrivalsMode(false)}>
        {t('arrivalsdepartures.departures')}
      </h3>
    </div>
  );
};

export default ArrivalsDeparturesSwitcher;
